import blog from '../assets/images/blog/blogsSvg.svg';
import business from '../assets/images/blog/businessSvg.svg';
import coding from '../assets/images/blog/codingSvg.svg';
import graphics from '../assets/images/blog/graphicsSvg.png';
import growth from '../assets/images/blog/growthSvg.svg';
import website from '../assets/images/blog/websiteSvg.svg';

const serviceLogos = {
    'Coding': coding,
    'Business': business, 
    'Website': website, 
    'Blogs': blog, 
    'Graphics': graphics, 
    'Growth': growth
}

export default serviceLogos;